(() => {
  /*
    Marjo et son petit robot pref 🤖

    Ce script calcule l’espace minimal à prévoir pour les numéros d’adresse Zepto.
    Il utilise un vrai tableau de mesures par caractère selon la collection et la taille. On utilise la mesure le plus large du gabarit.

    Ce que fait le code :
    - détecte le produit actif (Contemporaine, Contemporaine XL, Prestige)
    - détecte la taille sélectionnée
    - détecte l’orientation (Horizontal / Vertical)
    - lit le champ "Numéro de porte"
    - calcule :
      Horizontal = somme des largeurs des gabarits, hauteur fixe
      Vertical = largeur du gabarit le plus large présent, hauteur = nb caractères × hauteur fixe
    - traite l’espace comme un caractère standard
    - convertit toujours le texte en majuscules
    - arrondit l’affichage au 0.25 supérieur
    - adapte le texte affiché selon la langue du site

    Problématique réglée :
    - remplace l’ancienne logique par nombre de caractères + déductions
    - suit maintenant les mesures réelles du gabarit
    - permet une logique cohérente pour Contemporaine toutes tailles + Prestige
    - affiche le texte en français ou en anglais selon la langue active du site

    Pages concernées :
    - pages produits Zepto compatibles

    App impliquée :
    - Zepto Product Personalizer
  */

  const handle = window.MAC_PRODUCT_HANDLE;
  if (!handle) return;

  const PRODUCT_TYPE =
    handle === "contemporaine" ? "contemporaine"
    : handle === "contemporaine-xl" ? "contemporaine_gf"
    : handle === "prestige" ? "prestige"
    : null;

  if (!PRODUCT_TYPE) return;

  /*
    Tableau maître des mesures
    - standardWidth = largeur par défaut si caractère introuvable
    - height = hauteur fixe d’un caractère
    - chars = largeur par caractère

    Note :
    - l’espace " " est traité comme largeur standard
    - en vertical, la largeur = le caractère le plus large réellement présent
  */
  const MEASURE_TABLE = {
    contemporaine: {
      6: {
        standardWidth: 4.25,
        height: 6,
        chars: {
          "0": 4.25, "1": 2.5,  "2": 4.25, "3": 4.25, "4": 4.25,
          "5": 4.25, "6": 4.25, "7": 4.25, "8": 4.25, "9": 4.25,
          "A": 4.75, "B": 4.75, "C": 4.75, "D": 4.75, "E": 4.75, "F": 4.75,
          "-": 2.75
        }
      },
      9: {
        standardWidth: 6.75,
        height: 9.5,
        chars: {
          "0": 6.75, "1": 3.5,  "2": 6.75, "3": 6.75, "4": 6.75,
          "5": 6.75, "6": 6.75, "7": 6.75, "8": 6.75, "9": 6.25,
          "A": 7.5,  "B": 7.5,  "C": 7.5,  "D": 7.5,  "E": 7.5,  "F": 7.5,
          "-": 3.5
        }
      },
      12: {
        standardWidth: 8.75,
        height: 12.5,
        chars: {
          "0": 8.75, "1": 5,    "2": 8.75, "3": 8.75, "4": 8.75,
          "5": 8.75, "6": 8.75, "7": 8.75, "8": 8.75, "9": 8.25,
          "A": 9,    "B": 9,    "C": 9,    "D": 9,    "E": 9,    "F": 9,
          "-": 3.5
        }
      }
    },

    contemporaine_gf: {
      18: {
        standardWidth: 13.5,
        height: 19.25,
        chars: {
          "0": 13.5, "1": 7.75, "2": 13.5, "3": 13.5, "4": 13.5,
          "5": 13.5, "6": 13.5, "7": 13.5, "8": 13.5, "9": 12.75
        }
      },
      24: {
        standardWidth: 18,
        height: 25.5,
        chars: {
          "0": 18,   "1": 10,   "2": 18,   "3": 18,   "4": 18,
          "5": 18,   "6": 18,   "7": 18,   "8": 18,   "9": 17
        }
      }
    },

    prestige: {
      8: {
        standardWidth: 6.125,
        height: 9.75,
        chars: {
          "0": 7,
          "1": 3.25,
          "2": 6.125, "3": 6.125, "4": 6.125, "5": 6.125,
          "6": 6.125, "7": 6.125, "8": 6.125, "9": 6.125
        }
      }
    }
  };

  function formatInches(n) {
    // Arrondi au 0.25 supérieur pour l’affichage seulement
    const rounded = Math.ceil(n * 4) / 4;
    return (rounded % 1 === 0 ? rounded.toFixed(0) : String(rounded)) + '"';
  }

  function getLanguage() {
    return (document.documentElement.lang || 'fr').toLowerCase();
  }

  function getDimensionLabel(width, height) {
    const lang = getLanguage();

    if (lang.startsWith('en')) {
      return `Minimum space required: Width ${formatInches(width)} x Height ${formatInches(height)}`;
    }

    return `Espace minimal à prévoir : Largeur ${formatInches(width)} x Hauteur ${formatInches(height)}`;
  }

  function isVisible(el) {
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    if (el.offsetParent === null) return false;
    return true;
  }

  function getHouseInput() {
    const nodes = document.querySelectorAll(
      'input[name="properties[Numéro de porte]"], textarea[name="properties[Numéro de porte]"]'
    );
    for (const el of nodes) {
      if (el.type === 'hidden') continue;
      if (!isVisible(el)) continue;
      return el;
    }
    return null;
  }

  function getOrientation() {
    const nodes = document.querySelectorAll(
      '.pplr-drop-item.active[data-value="Horizontal"], .pplr-drop-item.active[data-value="Vertical"]'
    );
    for (const el of nodes) {
      if (!isVisible(el)) continue;
      const v = el.getAttribute('data-value');
      if (v === "Horizontal") return "H";
      if (v === "Vertical") return "V";
    }
    return null;
  }

  function getSize() {
    if (PRODUCT_TYPE === "prestige") return 8;

    const sizeInput = document.querySelector('input[name="properties[Taille]"]');
    const v = sizeInput?.value?.trim();
    if (v && /^\d+$/.test(v)) return parseInt(v, 10);

    const nodes = document.querySelectorAll('.pplr-drop-item.active');
    for (const el of nodes) {
      if (!isVisible(el)) continue;
      const raw = el.getAttribute('data-value') || el.textContent || '';
      const m = raw.match(/\b(6|9|12|18|24)\b/);
      if (m) return parseInt(m[1], 10);
    }

    return null;
  }

  function getMeasureConfig(size) {
    return MEASURE_TABLE[PRODUCT_TYPE]?.[size] || null;
  }

  function getCharWidth(ch, config) {
    if (!config) return null;

    // Espace = caractère standard
    if (ch === " ") return config.standardWidth;

    return config.chars[ch] ?? config.standardWidth;
  }

  function computeHorizontalWidth(str, config) {
    let total = 0;
    for (const ch of str) {
      total += getCharWidth(ch, config);
    }
    return total;
  }

  function computeVerticalWidth(str, config) {
    let maxW = 0;
    for (const ch of str) {
      const w = getCharWidth(ch, config);
      if (w > maxW) maxW = w;
    }
    return maxW;
  }

  function ensureOutputEl(inputEl) {
    let out = inputEl.parentElement?.querySelector('.mac-zepto-required-dim');
    if (out) return out;

    out = document.createElement('div');
    out.className = 'mac-zepto-required-dim';
    out.style.display = 'none';
    inputEl.insertAdjacentElement('afterend', out);
    return out;
  }

  function update() {
    const inputEl = getHouseInput();
    if (!inputEl) return;

    const out = ensureOutputEl(inputEl);

    const raw = (inputEl.value || '').trim();

    if (!raw) {
      out.style.display = 'none';
      out.textContent = '';
      return;
    }

    const orientation = getOrientation();
    const size = getSize();
    const config = getMeasureConfig(size);

    if (!orientation || !size || !config) {
      out.style.display = 'none';
      out.textContent = '';
      return;
    }

    // Toujours en majuscules
    const normalized = raw.toUpperCase();

    // On garde les espaces comme caractères valides
    // mais on enlève retours de ligne / tabs si textarea
    const cleaned = normalized.replace(/[\n\r\t]+/g, '');

    if (!cleaned) {
      out.style.display = 'none';
      out.textContent = '';
      return;
    }

    let width = null;
    let height = null;

    if (orientation === "H") {
      width = computeHorizontalWidth(cleaned, config);
      height = config.height;
    } else {
      width = computeVerticalWidth(cleaned, config);
      height = cleaned.length * config.height;
    }

    out.textContent = getDimensionLabel(width, height);
    out.style.display = 'block';
  }

  function bind() {
    const fieldSelector =
      'input[name="properties[Numéro de porte]"], textarea[name="properties[Numéro de porte]"]';

    const scheduleUpdate = () => setTimeout(update, 0);

    document.addEventListener('input', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches(fieldSelector)) scheduleUpdate();
    }, true);

    document.addEventListener('keyup', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches(fieldSelector)) scheduleUpdate();
    }, true);

    document.addEventListener('paste', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches(fieldSelector)) setTimeout(update, 0);
    }, true);

    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches('.pplr-drop-item') || t.closest('.pplr-drop-item')) {
        setTimeout(update, 150);
      }
    });

    update();
  }

  // Zepto peut injecter le DOM après chargement
  const start = Date.now();
  const timer = setInterval(() => {
    if (getHouseInput()) {
      clearInterval(timer);
      bind();
    } else if (Date.now() - start > 8000) {
      clearInterval(timer);
    }
  }, 200);

})();